const floatingPointToCommaString = floatingPoint => {
  return floatingPoint
    ? floatingPoint.toFixed(2).replace(".", ",")
    : floatingPoint
}

export default floatingPointToCommaString
